import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBGlobalCake',
        endpoint:           endpoints.cmdb.globalCake,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            total:   response.count,
            results: !response.results ? [] : response.results.map(item => ({
                className: item.class_name,
                amount:    item.amount,
                y:         item.amount
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBGlobalCake.js